import formatMoney from "../../../formatMoney";
import { parseMoney } from "./utils";

async function purchasesFormatReport(purchases = [], taxableDate = new Date()) {
  const formattedPurchase = purchases.reduce((acc, item) => {
    const supplierId = item?.supplier?.id;
    if (!supplierId) return acc;

    const { gross, vat, net, vatExempt, zeroRated, category, supplier } = item;

    const fullName = [
      supplier.lastName,
      supplier.firstName,
      supplier.middleName,
    ]
      .filter(Boolean)
      .join(", ");
    const address = [
      supplier.region,
      supplier.province,
      supplier.city,
      supplier.barangay,
      supplier.street,
    ]
      .filter(Boolean)
      .join(", ");
    const grossValue = parseMoney(gross || 0);
    const taxableAmount = parseMoney(supplier?.isVatable ? net : 0);
    const grossTaxableAmount = parseMoney(supplier?.isVatable ? gross : 0);
    const vatValue = parseMoney(vat || 0);
    const netValue = parseMoney(net || 0);
    const vatExemptValue = parseMoney(vatExempt || 0);
    const zeroRatedValue = parseMoney(zeroRated || 0);
    const categoryValue = category || "Others";

    if (!acc[supplierId]) {
      acc[supplierId] = {
        //supplierId,
        supplier: item.supplier,
        taxableDate: taxableDate.toISOString(),
        fullName,
        address,
        totalGross: 0,
        taxableAmount: 0,
        netAmount: 0,
        grossTaxableAmount: 0,
        vatAmount: 0,
        vatExemptAmount: 0,
        zeroRatedAmount: 0,
        servicesAmount: 0,
        capitalGoodsAmount: 0,
        otherGoodsAmount: 0,
      };
    }

    switch (categoryValue) {
      case "Services":
        acc[supplierId].servicesAmount += grossValue;
        break;
      case "Capital Goods":
        acc[supplierId].capitalGoodsAmount += grossValue;
        break;
      default:
        acc[supplierId].otherGoodsAmount += grossValue;
        break;
    }

    acc[supplierId].totalGross += grossValue;
    acc[supplierId].taxableAmount += taxableAmount;
    acc[supplierId].netAmount += netValue;
    acc[supplierId].zeroRatedAmount += zeroRatedValue;
    acc[supplierId].vatExemptAmount += vatExemptValue;
    acc[supplierId].vatAmount += vatValue;
    acc[supplierId].grossTaxableAmount += grossTaxableAmount;

    return acc;
  }, {});

  return Object.values(formattedPurchase).map((s) => ({
    ...s,
    totalGross: formatMoney(
      s.taxableAmount + s.vatExemptAmount + s.zeroRatedAmount,
    ),
    vatExemptAmount: formatMoney(s.vatExemptAmount),
    zeroRatedAmount: formatMoney(s.zeroRatedAmount),
    taxableAmount: formatMoney(s.taxableAmount),
    servicesAmount: formatMoney(s.servicesAmount),
    capitalGoodsAmount: formatMoney(s.capitalGoodsAmount),
    otherGoodsAmount: formatMoney(s.otherGoodsAmount),
    vatAmount: formatMoney(s.vatAmount),
    grossTaxableAmount: formatMoney(s.taxableAmount + s.vatAmount),
    netAmount: formatMoney(s.netAmount),
  }));
}

export default purchasesFormatReport;
